(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-strap-pro"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStrap(root) {
    var track = root.querySelector('.aura-strap__track');
    if (!track) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.aura-strap__dot'));
    var items = root.querySelectorAll('.aura-strap__item');
    var count = dots.length || items.length;
    var current = 0;

    function setActive(i) {
      dots.forEach(function (d) {
        d.classList.remove('is-active');
        d.setAttribute('aria-selected', 'false');
      });
      if (dots[i]) {
        dots[i].classList.add('is-active');
        dots[i].setAttribute('aria-selected', 'true');
      }
      current = i;
    }

    function go(i) {
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); });
    });

    /* Keep the active dot in sync when the user swipes the track. */
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    });

    if (root.dataset.autoplay === 'true' && root.dataset.mobileLayout === 'slider') {
      var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5;
      setInterval(function () {
        if (window.innerWidth > 749) return; /* slider is mobile-only */
        go((current + 1) % count);
      }, speed * 1000);
    }
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-aura-strap]');
    Array.prototype.slice.call(roots).forEach(function (r) {
      if (r.__auraStrap) return;
      r.__auraStrap = true;
      initStrap(r);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {

  const mobileNav =
    document.querySelector('.aura-mobile-nav');

  const navVisible =
    mobileNav &&
    !mobileNav.classList.contains('aura-mobile-nav--hidden');

  /* Reserve space below the header for the (absolute) mobile nav ONLY while it
     is visible. When it slides away, collapse the reservation so the page and
     the sticky filter bar ride up flush to the header. Set this BEFORE
     measuring so offsetHeight reflects the current margin. */
  document.documentElement.style.setProperty(
    '--aura-mnav-height',
    navVisible ? `${mobileNav.offsetHeight}px` : '0px'
  );

  let headerHeight = this.header.offsetHeight;

  if (navVisible) {
    /* Measure to the mobile nav's real bottom edge. The reserved nav margin
       is already folded into this.header.offsetHeight, so adding the nav
       height again double-counted it and left a gap below the header. */
    const headerTop = this.header.getBoundingClientRect().top;
    const navBottom = mobileNav.getBoundingClientRect().bottom;
    headerHeight = Math.round(navBottom - headerTop);
  }

  document.documentElement.style.setProperty(
    '--header-height',
    `${headerHeight}px`
  );

}

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.setHeaderHeight();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
